<template>
  <div class="clearfix">
    <!-- <el-tree :data="menu"  show-checkbox default-expand-all node-key="id" ref="tree" highlight-current :props="defaultProps">
	</el-tree> -->
    <div class="menuManage fl" id="menuManage">
      <div class="menumtitle">
        菜单列表
      </div>
      <ul v-for="(item,index1) in menu">
      	<i class="menuicon" :class="item.icon"></i>
      	{{item.menu_name}}
      	<li style="padding-left: 30px" v-for="(item2,index2) in item.children">  		
      		<ul >  			
      			<div @click="choose(item2.pk_menu,item2.grade,index1,index2)" class="caidan" :class="{bgactive:isbgactive == item2.pk_menu}"><i class="menuicon" :class="item2.icon"></i>{{item2.menu_name}}</div>
      			<li v-for="(item3,index3) in item2.children" v-on:click="choose(item3.pk_menu,item3.grade,index1,index2,index3)" class="libg" :class="{bgactive:isbgactive == item3.pk_menu&&item3.grade=='2'}" style="padding-left: 30px">
      				{{item3.menu_name}}
      			</li>
      		</ul>
      	</li>
      </ul>
    </div>
    <div class="fl" style="width:70%;background-color:#fff;padding: 10px 20px;margin-bottom:10px;box-sizing: border-box">
      <div class="menumtitle">
        菜单详情
      <el-button size="small" type="primary" class="fr" @click="addmenu">添加自定义新菜单</el-button>
      </div>
       <el-form :model="menuForm" :rules="rules" ref="menuForm" label-width="120px" class="demo-ruleForm my user" style="width:100%;
    ">
       <!--  <el-form-item label="上级菜单编码：" class="rmsg">
            <el-input type="text" v-model="menuForm.parentId" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item> 
        <el-form-item label="上级菜单名称：" class="rmsg">
            <el-input type="text" v-model="menuForm.parentLabel" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item> -->
     <!--  <el-form-item label="菜单类型：" class="rmsg" style="">
        <el-select @change="selectchange2" filterable value-key="parentId" v-model="menutypename" clearable placeholder="请选择菜单类型" style="width:100%;" auto-complete="off">
          <el-option v-for="item in menutypeList" :key="item.menutypename" :label="item.menutype" :value="item"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="菜单类型：" class="rmsg">
            <el-select v-model="menutypename" placeholder="请选择菜单类型" class="" @change="selectchange2"  style="width:100%;">
              <el-option v-for="item in menutypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
      <el-form-item label="上级菜单：" class="rmsg" style="">
        <el-select @change="selectchange" filterable value-key="pk_menu_father" v-model="menuForm.parentLabel" clearable placeholder="请选择上级菜单" style="width:100%;" auto-complete="off">
          <el-option v-for="item in parentMenuList" :key="item.pk_menu_father" :label="item.parentLabel" :value="item"></el-option>
        </el-select>
      </el-form-item>

       <!--  <el-form-item label="菜单编码：" class="rmsg">
            <el-input type="text" v-model="menuForm.menu_code" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item>  -->
        <el-form-item label="菜单名称：" prop="menu_name" class="rmsg">
            <el-input type="text" v-model="menuForm.menu_name" auto-complete="off" @blur="selectName" style="margin-left: 13px;" clearable></el-input>
        </el-form-item>
        </el-form-item> 
       
        <el-form-item label="链接地址：" class="rmsg" >
            <el-input type="text" v-model="menuForm.menu_path" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item> 
       <!--  <el-form-item label="菜单等级：" class="rmsg" style="">
        <el-select @change="selectchange2" filterable value-key="parentId" v-model="menuForm.grade" clearable placeholder="请选择门店" style="width:100%;" auto-complete="off">
            <el-option v-for="item in gradeList" :key="item.gradeid" :label="item.grade" :value="item"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="等级：" prop="grade" class="rmsg">
            <el-input type="text" v-model="menuForm.grade" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="图标：" class="rmsg">
            <el-input type="text" v-model="menuForm.icon" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item>

         <el-form-item label="备注：" class="rmsg">
            <el-input type="text" v-model="menuForm.memo" auto-complete="off" style="margin-left: 13px;" clearable></el-input>
        </el-form-item>
        </el-form-item> 
        <el-form-item label="是否虚拟菜单：" class="rmsg">
            <div class="item-all-check2" >
                <span  class="checkbox-btn item-check-btn" v-bind:class="{'checked':menuForm.is_virtual=='1'}" @click="toggleChecked">
                   <span class="iconfont icon-duigou gou" style="font-size: 12px"></span>
                </span>
                <span v-if="menuForm.is_virtual=='1'">&nbsp;&nbsp;&nbsp;是</span>
                <span v-else>&nbsp;&nbsp;&nbsp;否</span>
            </div>
        </el-form-item>
        <div v-if="menuForm.grade =='1'">
            <el-button size="medium" type="danger" class="fr" @click="delMenum"  v-if="!saveFlag">删除</el-button>
            <el-button size="medium" type="primary" class="fr butinpfr" v-if="!saveFlag&&bigzhuan" @click="addmenuForm">添加子节点</el-button>
            <el-button size="medium" type="primary" class="fr butinpfr" @click="submitChildForm('menuForm')" v-if="saveFlag">保存</el-button>
            <el-button size="medium" type="warning" class="fr butinpfr" v-else @click="submitForm('menuForm')">提交修改</el-button>
       </div>
       <div v-else>
            <el-button size="medium" type="warning" class="fr" @click="cancel" v-if="!saveFlag">返回</el-button>
            <el-button size="medium" type="primary" class="fr butinpfr" v-if="!saveFlag&&bigzhuan" @click="addmenuForm">添加子节点</el-button>
            <el-button size="medium" type="primary" class="fr butinpfr" @click="submitChildForm('menuForm')" v-if="saveFlag">保存</el-button>
            <el-button size="medium" type="warning" class="fr butinpfr" @click="submitForm('menuForm')" v-else>提交修改</el-button>
            <el-button size="medium" type="danger" class="fr butinpfr" @click="delMenum" v-if="!saveFlag"> 删除</el-button>
       </div>
    </el-form>
    </div>
    <!-- model end -->
    <div class=""  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
  </div>
</template>
<style scoped>
	.menuManage {
      width:24%;
		  min-width: 216px;
	    background-color: #fff;
	    padding: 10px 20px;
      margin-right: 24px;
      box-sizing: border-box;
	}
  #menuManage {
    height: 100%;
  }
	.menuManage ul{
		cursor: pointer;
	}
	/*dotted solid double dashed*/
	.menuManage li{
		border-left: 1px dotted #afafaf;
		cursor: pointer;
	}
	i.menuicon{
		font-size: 14px !important;
		margin-right: 5px;
	}
	.caidan{
    display: inline-block;
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  .libg{
     height: 26px;
     line-height: 26px;
  }
  .bgactive{
		background-color: #B9D1EA;
	}
  .butinpfr{
    margin:0 20px 20px 0;
  }
  .menumtitle{
    height:40px;
    line-height:40px;
    border-bottom: 1px dotted #afafaf;
    margin-bottom: 10px;
  }
</style>
<script>
// import MessageModel from '../../components/MessageModel'
export default {
  name: '',
  data () {
    // var validatId = (rule, value, callback) => {
    //         if (value === '') {
    //             callback(new Error('菜单编码不能为空'));
    //         }else {
    //             callback();
    //         }
    // };
    var validateLabel = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('菜单名称不能为空'));
        } else {
            callback();
        }
    };    
    // var validatGrade = (rule, value, callback) => {
    //         if (value === '') {
    //             callback(new Error('等级不能为空'));
    //         }else {
    //             callback();
    //         }
    // };   
    return {
        flag:false,
        msgShow:false,
        modelFlag:false,
        modelFlag2:false,
        butflag:true,
        butflag2:true,
        msg:'', 
        butmsg:'确认', 
        butmsg2:'确认', 
        menuFlag:true,
        fullscreenLoading:true,
        bigzhuan:true,
        methodName:'', 
        utilpath:'',
        isbgactive:'',
        index1:'',
        index2:'',
        index3:'',
        menu: [],
        butindex: true,
        firstmenuForm:'',
        saveFlag:true,
      	menuForm:{
          creatorcode:'',
          creatorname:'',
          modifiercode:'',
          modifiername:'', 
          pk_menu_father:'',
          parentLabel:'',
          menu_code:'',
          menu_name:'',
          menu_path:'',
          grade:'',
          icon:'',
          menutype:'0',
          memo:'',
          is_virtual:'1'
        },
        parentMenuList:[],
        gradeList:[
          {
            gradeid:'1',
            grade:1
          },
          {
            gradeid:'2',
            grade:2
          },
        ], 
        user:{},
        menutypename:0, 
        menutypeList:[
          {
             label:'门店菜单',
             value:0
          },
          {
            label:'系统菜单',
            value:1
          }
        ],
        defaultProps: {
	        children: 'children',
	        label: 'label'
	      },
        rules: {  
            // menu_code: [
            //     { required: true, trigger: 'blur', validator: validatId }
            // ],
            menu_name: [
                { required: true, trigger: 'blur', validator: validateLabel }
            ], 
            // grade: [
            //     { required: true, trigger: 'blur', validator: validatGrade }
            // ]
        }
    }
  },
  mounted() {
    this.utilpath = this.axios.defaults.baseURL;
    this.user =  JSON.parse(window.localStorage.getItem("userInfo"));
	  // this.init();
    this.selectMenu();
  },
  methods:{
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
          //  console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='delMenum'){  
                  this.fullscreenLoading = true;
                  var param={
                    pk_menu:this.menuForm.pk_menu,
                  }
                  this.$http.post(this.utilpath + '/deleteMenu',param, { emulateJSON: true,_timeout:600 }).then((res) => { 
                        if (res.data.status == '0') {
                          this.fullscreenLoading = false;
                          this.msgShow =false;
                          this.menu = res.data.resultList;
                          this.$message({
                            showClose: true,
                            message: '删除成功！',
                            type: 'success'
                          });
                          this.menuForm = {
                              creatorcode:'',
                              creatorname:'',
                              modifiercode:'',
                              modifiername:'', 
                              pk_menu_father:'',
                              parentLabel:'',
                              menu_code:'',
                              menu_name:'',
                              menu_path:'',
                              grade:'',
                              icon:'',
                              menutype:'0',
                              memo:'',
                              is_virtual:'1'
                          };
                        } else if(res.data.status == '9'){
                            this.$router.push({path:'/ui/login',query:{msg:9}});
                        } else {
                          this.fullscreenLoading = false;
                          this.modelFlag = true;
                          this.msgShow = true;
                          this.methodName = 'message';
                          this.msg = res.data.message;
                          this.butflag =false;
                          this.butmsg='知道了';
                        };
                      }, (err) => {
                        this.fullscreenLoading = false;
                        this.msgShow =false;
                        this.modelFlag = true;
                        this.methodName = 'message';
                        this.msg = '连接新增用户接口失败';
                        this.butflag =false;
                        this.butmsg='知道了';
                  });
              }else if(this.methodName =='submitChildForm'){ 
                    this.fullscreenLoading = true;
                    this.menuForm.creatorcode  =this.user.user_code;
                    this.menuForm.creatorname  =this.user.user_name;
                    if(this.menuForm.pk_menu_father==''||this.menuForm.pk_menu_father==null){
                        this.menuForm.grade=1;
                    }
                   // console.log("打印新增数据："+JSON.stringify(this.menuForm))
                    this.$http.post(this.utilpath + '/insertMenu',this.menuForm, { emulateJSON: true,_timeout:600 }).then((res) => { 
                        if (res.data.status == '0') {
                          this.fullscreenLoading = false;
                          this.msgShow =false;
                          this.menu = res.data.resultList;
                          this.$message({
                            showClose: true,
                            message: '新增成功！',
                            type: 'success'
                          });
                        } else if(res.data.status == '9'){
                            this.$router.push({path:'/ui/login',query:{msg:9}});
                        } else {
                          this.fullscreenLoading = false;
                          this.modelFlag = true;
                          this.msgShow = true;
                          this.methodName = 'message';
                          this.msg = res.data.message;
                          this.butflag =false;
                          this.butmsg='知道了';
                        };
                      }, (err) => {
                        this.fullscreenLoading = false;
                        this.msgShow =false;
                        this.modelFlag = true;
                        this.methodName = 'message';
                        this.msg = '连接新增菜单接口失败';
                        this.butflag =false;
                        this.butmsg='知道了';
                    });
              }else if(this.methodName =='submitMenu'){
                    this.fullscreenLoading = true;
                    this.menuForm.modifiercode  =this.user.user_code;
                    this.menuForm.modifiername  =this.user.user_name;
                   // console.log("打印参数："+JSON.stringify(this.menuForm));
                    this.$http.post(this.utilpath + '/updateMenu',this.menuForm, {emulateJSON: true,_timeout:600}).then((res) => { 
                        if (res.data.status == '0') {
                          this.fullscreenLoading = false;
                          this.menu = res.data.resultList;
                          this.$message({
                            showClose: true,
                            message: '修改成功！',
                            type: 'success'
                          });
                        } else if(res.data.status == '9'){
                            this.$router.push({path:'/ui/login',query:{msg:9}});
                        } else {
                          this.fullscreenLoading = false;
                          this.modelFlag = true;
                          this.msgShow = true;
                          this.methodName = 'message';
                          this.msg = res.data.message;
                          this.butflag =false;
                          this.butmsg='知道了';
                        };
                      }, (err) => {
                        this.fullscreenLoading = false;
                        this.msgShow =false;
                        this.modelFlag = true;
                        this.methodName = 'message';
                        this.msg = '连接新增菜单接口失败';
                        this.butflag =false;
                        this.butmsg='知道了';
                    });
              }
      }else{
        this.fullscreenLoading = false;
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },  
    selectName(){
    //  console.log("进入菜单名称离开焦点事件："+this.menuForm.menu_name);
        var parm={
          menu_name:this.menuForm.menu_name,
        }
       // console.log("进入菜单名称离开焦点事件："+JSON.stringify(parm));
        this.$http.post(this.utilpath + '/selectMenuNameIsExist',parm, {emulateJSON: true,_timeout:600}).then((res) => { 
                      if (res.data.status == '-1') { 
                          this.fullscreenLoading = false;
                          this.modelFlag = true;
                          this.msgShow = true;
                          this.methodName = 'message';
                          this.msg = res.data.message;
                          this.butflag =false;
                          this.butmsg='知道了';
                          this.menuForm.menu_name ='';
                        } else if(res.data.status == '9'){
                          this.fullscreenLoading =false;
                            this.$router.push({path:'/ui/login',query:{msg:9}});
                        } ;
                      }, (err) => {
                        this.fullscreenLoading = false;
                        this.modelFlag = true;
                        this.msgShow =false;
                        this.methodName = 'message';
                        this.msg = '连接查询菜单接口失败';
                        this.butflag =false;
                        this.butmsg='知道了';
                    });
    },
    returnMsg2(flag) { 
      this.modelFlag = false; 
       if (flag) {
       // console.log("---进来了！！！----" + this.methodName);
        if (this.methodName == 'message') {

        } 
      }
    },
    addmenu(){
      this.saveFlag = true;
      this.menutypename=0;
      this.menuForm ={
          creatorcode:'',
          creatorname:'',
          modifiercode:'',
          modifiername:'', 
          pk_menu_father:'',
          parentLabel:'',
          menu_code:'',
          menu_name:'',
          menu_path:'',
          grade:'',
          icon:'',
          menutype:'0',
          memo:'',
          is_virtual:'1'
        };
        this.isbgactive ='';
    },
    toggleChecked(){
      var ddr = this.menuForm.is_virtual;
     // console.log("--------前-------"+this.menuForm.is_virtual);
      this.menuForm.is_virtual = (ddr=="0"?"1":"0");
     // console.log("--------后-------"+this.menuForm.is_virtual);
    },
  	choose(id,grade,index1,index2,index3){
       
      this.saveFlag = false;
      // console.log("测试下标"+this.index1+','+index1+','+this.index2 +','+index2+','+this.index3 +','+ index3);
      // if(this.menuFlag&&this.index1 != index1||this.index2 != index2||this.index3 != index3){ 
            if(grade=='2'){
              this.isbgactive = id;
              this.menutypename=parseInt(this.menu[index1].children[index2].children[index3].menutype);
              this.menuForm = {
                  pk_menu:this.menu[index1].children[index2].children[index3].pk_menu, 
                  pk_menu_father:this.menu[index1].children[index2].pk_menu,
                  parentLabel:this.menu[index1].children[index2].menu_name,
                  menu_code:this.menu[index1].children[index2].children[index3].menu_code,
                  menu_name:this.menu[index1].children[index2].children[index3].menu_name,
                  menu_path:this.menu[index1].children[index2].children[index3].menu_path,
                  grade:this.menu[index1].children[index2].children[index3].grade,
                  icon:this.menu[index1].children[index2].children[index3].icon,
                  menutype:this.menu[index1].children[index2].children[index3].menutype,
                  memo:this.menu[index1].children[index2].children[index3].memo,
                  is_virtual:this.menu[index1].children[index2].children[index3].is_virtual,
                  // is_virtual:'0'
              };
              this.bigzhuan = false;
            }else{
              // console.log("打印id0---："+id);
              // console.log("打印---："+index2);
              // console.log("打印id1---："+this.menu[index1].menu_code);
              // console.log("打印id2---："+this.menu[index1].children[index2].menu_code);
              // this.menutypename=this.menu[index1].menutype
              this.bigzhuan =true;
              this.isbgactive = id;
              this.menutypename=parseInt(this.menu[index1].children[index2].menutype);
              this.menuForm.pk_menu=this.menu[index1].children[index2].pk_menu;
              this.menuForm.pk_menu_father='';
              this.menuForm.parentLabel='';
              this.menuForm.menu_code=this.menu[index1].children[index2].menu_code;
              this.menuForm.menu_name=this.menu[index1].children[index2].menu_name;
              this.menuForm.menu_path=this.menu[index1].children[index2].menu_path;
              this.menuForm.grade=this.menu[index1].children[index2].grade;
              this.menuForm.icon=this.menu[index1].children[index2].icon;
              this.menuForm.menutype=this.menu[index1].children[index2].menutype;
              this.menuForm.memo=this.menu[index1].children[index2].memo; 
              this.menuForm.is_virtual=this.menu[index1].children[index2].is_virtual; 
            }
           this.firstmenuForm = JSON.parse(JSON.stringify(this.menuForm));
      // console.log("打印选择的菜单"+JSON.stringify(this.firstmenuForm));
      // }else{
      //    this.menuForm ={
      //     pk_menu_father:'',
      //     pk_menu_father:'',
      //     parentLabel:'',
      //     menu_code:'',
      //     menu_name:'',
      //     menu_path:'',
      //     grade:'',
      //     icon:'',
      //     menutype:'0',
      //     memo:'',
      //     is_virtual:'0'
      //   };
      // }
      // this.index1 = index1;
      // this.index2 = index2;
      // this.index3 = index3;
      //  this.menuFlag = !this.menuFlag
      // console.log("打印grade："+grade);
      // console.log("打印id："+id+"-------");
      this.selectselectTopMenu();
  	},
    selectMenu(){
        this.$http.post(this.utilpath + '/selectMenu', { emulateJSON: true,_timeout:600 }).then((res) => {
            //  console.log("打印返回值" + JSON.stringify(res.data));
              // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
              if (res.data.status == '0') {
                 this.fullscreenLoading = false;
                 this.menu = res.data.resultList;
                // console.log("打印菜单列表" + JSON.stringify(this.menu));
                 if(this.menuForm.pk_menu_father==''||this.menuForm.pk_menu_father==null||this.menuForm.pk_menu_father==undefined){
                    this.menuForm.grade = 1;
                  }
              } else if (res.data.status == '-1') {
                this.menu =[];
                this.fullscreenLoading = false;
                this.$message({
                  showClose:true,
                  message:'暂无菜单数据',
                  type:'info'
                })
                this.count = res.data.countNum;
               // console.log("-----暂无数据！！！");
              } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
                this.fullscreenLoading = false;
                this.modelFlag = true;
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了'; 
              } 
            }, (err) => {
              this.fullscreenLoading = false;
              this.msgShow =false;
              this.modelFlag = true;
              this.methodName = 'message';
              this.msg = '连接获取所以菜单信息接口失败';
              this.butflag =false;
              this.butmsg='知道了'; 
              console.log(err);
          });
        var param={
          menutype:0,
        }
        this.$http.post(this.utilpath + '/selectTopMenu',param, { emulateJSON: true,_timeout:600 }).then((res) => {
              // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
              if (res.data.status == '0') {
                // this.fullscreenLoading = false;
                 this.parentMenuList = res.data.resultList;
                // console.log("打印货位" + JSON.stringify(this.parentMenuList));
              } else if (res.data.status == '-1') {
                this.parentMenuList=[];
                this.$message({
                  showClose:true,
                  message:'暂无数据',
                  type:'info'
                });
              //  console.log("-----暂无数据！！！");
              } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
                this.modelFlag = true;
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了'; 
              }

            }, (err) => {
              this.modelFlag = true;
              this.msgShow =false;
              this.methodName = 'message';
              this.msg = '连接获取所以菜单信息接口失败';
              this.butflag =false;
              this.butmsg='知道了'; 
              console.log(err);
          });
    },
    submitForm(formName){
        this.$refs[formName].validate((valid) => {
            if (valid) {//符合规则  
                  this.methodName = 'submitMenu';
                  this.modelFlag = true;
                  this.msgShow =false;
                  this.butflag = true;
                  this.butmsg='确认';
                  this.msg = '确定提交此次修改？' 
             } else {
              this.fullscreenLoading = false;
              this.$message({
                showClose: true,
                message: '失败！',
                type: 'error'
              }); 
              return false;
            } 
      });
    },
    submitChildForm(menuForm){
        
        this.methodName = 'submitChildForm';
        this.modelFlag = true;
        this.butflag = true;
        this.msgShow =false;
        this.butmsg='确认';
        this.msg = '确定新增此菜单？'
    },
    selectchange(value) { 
        this.menuForm.pk_menu_father = value.pk_menu_father;
        this.menuForm.parentLabel = value.parentLabel;   
        if(this.menuForm.pk_menu_father==''||this.menuForm.pk_menu_father==null||this.menuForm.pk_menu_father==undefined){
            this.menuForm.grade = 1;
            if(this.menuForm.parentLabel=='系统管理'){
            this.menuForm.menutype = '1';
            }
        }else{
            this.menuForm.grade = 2;  
        }
      //  console.log("打印菜单等级："+this.saveFlag+"等级"+this.menuForm.grade)
    },
    selectselectTopMenu(){
      var param={
          menutype:this.menuForm.menutype,
        }
        this.$http.post(this.utilpath + '/selectTopMenu',param, { emulateJSON: true ,_timeout:600}).then((res) => { 
              if (res.data.status == '0') { 
                 this.parentMenuList = res.data.resultList;
                // console.log("打印货位" + JSON.stringify(this.parentMenuList));
              } else if (res.data.status == '-1') {
                this.parentMenuList=[];
                this.$message({
                  showClose:true,
                  message:'暂无数据',
                  type:'info'
                });
               // console.log("-----暂无数据！！！");
              } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
                this.modelFlag = true;
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了'; 
              } 
            }, (err) => {
              this.modelFlag = true;
              this.msgShow =false;
              this.methodName = 'message';
              this.msg = '连接获取所以菜单信息接口失败';
              this.butflag =false;
              this.butmsg='知道了'; 
             // console.log(err);
        });
    },
    selectchange2(value) {  
       // console.log("打印value"+JSON.stringify(value));
        this.menuForm.menutype=value;
        this.selectselectTopMenu();
    },
    addmenuForm(){
      this.firstmenuForm = JSON.parse(JSON.stringify(this.menuForm));
      var pk_menu_father1 =this.menuForm.pk_menu;
      var parentLabel1 =this.menuForm.menu_name;
      var menutype1 =this.menuForm.menutype;
      this.menuForm ={  
          pk_menu_father:pk_menu_father1, 
          parentLabel:parentLabel1,
          menu_code:'',
          menu_name:'',
          menu_path:'',
          grade:'2',
          icon:'',
          menutype:menutype1,
          memo:'',
          is_virtual:'1'
        };
        this.butindex = false;
        this.saveFlag = true;
    },
    cancel(){
     // console.log("打印保存的菜单"+JSON.stringify(this.firstmenuForm));
      this.menuForm = JSON.parse(JSON.stringify(this.firstmenuForm));;
    },
    delMenum(){

        this.methodName = 'delMenum';
        this.modelFlag = true;
        this.msgShow =false;
        this.butflag = true;
        this.butmsg='确认';
        this.msg = '确定删除<'+this.menuForm.menu_name+'>菜单？'
    },
    selectParentMenu(){
          this.$http.post(this.utilpath + '/selectParentMenu', { emulateJSON: true,_timeout:600 }).then((res) => {
              // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
              if (res.data.status == '0') {
                var menus = res.data.resultList;
                this.parentMenuList = [];
                for (var i = menus.length - 1; i > -1; i--) {
                  this.parentMenuList.push({ pk_menu_father: menus[i].pk_menu_father, parentLabel: menus[i].parentLabel });
                }
               // console.log("打印货位" + JSON.stringify(this.parentMenuList));
              } else if (res.data.status == '-1') {
                this.parentMenuList = [];
                 this.$message({
                  showClose:true,
                  message:'暂无数据',
                  type:'info'
                })
               // console.log("-----暂无数据！！！");
              } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
                this.modelFlag = true; 
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了';
                // this.$alert(res.data.message, '失败信息', {
                //   confirmButtonText: '确定'
                // });
              }

            }, (err) => {
              this.modelFlag = true;
              this.msgShow =false;
              this.methodName = 'message';
              this.msg = '连接获取一级菜单接口信息接口失败';
              this.butflag =false;
              this.butmsg='知道了';
              // this.$alert('连接获取门店信息接口失败', '失败信息', {
              //   confirmButtonText: '确定'
              // });
              console.log(err);
          });
    },
  	init(){
      this.menu =[
               {
                  menu_code: 0,
                  menu_name: "门店菜单",
                  pk_menu:'00000000000000000000',
                  icon:"iconfont icon-mendian1",
                  grade:"0",
                  is_virtual:"0",
                  children: [
                      {
                        pk_menu_father:'00000000000000000000',
                        menu_code: 2,
                        menu_name: "门店收货",
                        pk_menu:'00000000000000000002',
                        icon:"iconfont icon-shouhuo",
                        children: [],
                        grade:"1",
                        is_virtual:"0",
                        menu_path :"/ui/receives"
                      },
                      {
                        pk_menu_father:'00000000000000000000',
                        menu_code: 3,
                        menu_name: "库存变更",
                        pk_menu:'00000000000000000003',
                        icon:"iconfont icon-kucun",
                        grade:"1",
                        is_virtual:"0",
                        children: [{
                              pk_menu_father:'00000000000000000003',
                              menu_code: 7,
                              menu_name: "结存表单",
                              pk_menu:'00000000000000000007',
                              children: [],
                              menu_path :"/ui/stock/kucun",
                              is_virtual:"0",
                              grade:"2"            
                            },{
                              pk_menu_father:'00000000000000000003',
                              menu_code: 8,
                              menu_name: "货位调整",
                              pk_menu:'00000000000000000008',
                              children: [],
                              menu_path:"/ui/stock/huowei3",
                              is_virtual:"0",
                              grade:"2"             
                            },{
                              pk_menu_father:'00000000000000000003',
                              menu_code: 9,
                              menu_name: "申请调拨",
                              pk_menu:'00000000000000000009',
                              children: [],
                              menu_path :"/ui/stock/diaobo2",
                              is_virtual:"0",
                              grade:"2"             
                            },{
                              pk_menu_father:'00000000000000000003',
                              menu_code: 10,
                              menu_name: "确认调拨",
                              pk_menu:'00000000000000000010',
                              children: [],
                              menu_path :"/ui/stock/diaochu",
                              is_virtual:"0",
                              grade:"2"             
                            },{
                              pk_menu_father:'00000000000000000003',
                              menu_code: 11,
                              menu_name: "库存盘点",
                              pk_menu:'00000000000000000011',
                              children: [],
                              menu_path :"/ui/stock/pandi2",
                              is_virtual:"0",
                              grade:"2"             
                            }
                        ]         
                      },
                      {
                        pk_menu_father:'00000000000000000000',
                        menu_code: 4,
                        menu_name: "门店请购单",
                        pk_menu:'00000000000000000004',
                        icon:"iconfont icon-dingdan",
                        grade:"1",
                        is_virtual:"0",
                        children: [{
                              pk_menu_father:'00000000000000000004',
                              menu_code: 12,
                              menu_name: "去购物",
                              pk_menu:'00000000000000000012',
                              children: [],
                              menu_path :"/ui/order/product",
                              is_virtual:"0",
                              grade:"2"              
                            },{
                              pk_menu_father:'00000000000000000004',
                              menu_code: 13,
                              menu_name: "待提交",
                              pk_menu:'00000000000000000013',
                              children: [],
                              menu_path :"/ui/order/tijiao",
                              is_virtual:"0",
                              grade:"2"                 
                            },{
                              pk_menu_father:'00000000000000000004',
                              menu_code: 14,
                              menu_name: "已提交",
                              pk_menu:'00000000000000000014',
                              children: [],
                              menu_path :"/ui/order/yitijiao",
                              is_virtual:"0",
                              grade:"2"                 
                            }
                        ]                  
                      },
                      {
                        pk_menu_father:'00000000000000000000',
                        menu_code: 5,
                        menu_name: "用户设置",
                        pk_menu:'00000000000000000005',
                        icon:"iconfont icon-shouhuo",
                        grade:"1",
                        menu_path :"/ui/settinguser",
                        is_virtual:"0",
                        children: []     
                      }
                ]
              },
              {
                  menu_code: 1,
                  menu_name: "系统菜单",
                  pk_menu:'00000000000000000001',
                  icon:"iconfont icon-quanxianguanli",
                  grade:"0",
                  is_virtual:"0",
                  children: [{
                        pk_menu_father:'00000000000000000001',
                        menu_code: 6,
                        menu_name: "系统管理",
                        pk_menu:'00000000000000000006',
                        icon:"iconfont icon-xitongguanli1",
                        grade:"1",
                        is_virtual:"0",
                        children: [
                            {  
                              pk_menu_father:'00000000000000000001',
                              menu_code: 15,
                              menu_name: "用户管理",
                              menu_path :"/ui/system/authority",
                              pk_menu:'00000000000000000015',
                              is_virtual:"0",
                              grade:"2"      
                            },
                            {
                              pk_menu_father:'00000000000000000001',
                              menu_code: 16,
                              menu_name: "菜单管理",
                              pk_menu:'00000000000000000016',
                              menu_path :"/ui/system/menuManage",
                              is_virtual:"0",
                              grade:"2"           
                            },
                            {
                              pk_menu_father:'00000000000000000001',
                              menu_code: 17,
                              menu_name: "角色管理",
                              pk_menu:'00000000000000000017',
                              menu_path :"/ui/system/roleManage",
                              is_virtual:"0",
                              grade:"2"            
                            }
                      ]
                    
                  }]
              }      
            ];
  		//     this.$http.post('api/Jurisdiction').then((res) => {
    //                 if(res.data.status == '0'){
	   //                  this.menu = res.data.result;
    //                   console.log("打印树"+JSON.stringify(this.menu));
	   //                  console.log("打印宽度"+document.getElementById("menuManage").offsetWidth+"打印高度"+document.getElementById("menuManage").offsetHeight);
    //                 }else{
    //                 	  this.$message({
    //       				          showClose: true,
    //       				          message: res.data.msg,
    //       				          type: 'error'
    //     				        });
    //                 };
    //         }, (err) => {
    //         	this.$message({
				//           showClose: true,
				//           message: err,
				//           type: 'error'
				// });
    //         });
  	},
  }
}
</script>




// WEBPACK FOOTER //
// src/views/system/menuManage.vue